import { DataFilter } from '@siclop/kstone-vue'

export class SalaryGridLevelFilter extends DataFilter {
  salaryGridId?: number

  constructor(data?: Partial<SalaryGridLevelFilter>) {
    super(data)
    if (data) {
      this.salaryGridId = data.salaryGridId
    }
  }

  override toQueryString(): string {
    let qs = super.toQueryString()
    if (this.salaryGridId != null) {
      qs += (qs ? '&' : '?') + `SalaryGridId=${this.salaryGridId}`
    }
    return qs
  }
}
